export default {
  activeItem: null,
  isRunning: true,
  continueToNextState: true,
};
